module.exports = __webpack_public_path__ + "img/20200905_150355.6751906c.jpg";